// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Tesamorelin Refill (systemic) 09.17.26" (ad3e35b5-09d3-437b-8856-3a56e84ece3e). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiTesamorelinRefillSystemicAnswerField } from './questions';

export const mdiTesamorelinRefillSystemic: FormType<mdiTesamorelinRefillSystemicAnswerField> =
  {
    name: 'Tesamorelin Refill (systemic)',
    validityLength: 25,
    questions: [
      {
        key: 'mdiTesamorelinRefillSystemic_sex',
        next: {
          switch: [
            {
              condition: { 'mdiTesamorelinRefillSystemic_sex.female': true },
              key: 'mdiTesamorelinRefillSystemic_pregnancy'
            },
            {
              condition: { 'mdiTesamorelinRefillSystemic_pregnancy.yes': true },
              key: 'mdiTesamorelinRefillSystemic_pregnantBreastfeedingPlanningPregnancy'
            }
          ],
          els: 'mdiTesamorelinRefillSystemic_sinceLastRefillProblemsHaving'
        }
      },
      {
        key: 'mdiTesamorelinRefillSystemic_pregnancy',
        next: {
          switch: [
            {
              condition: { 'mdiTesamorelinRefillSystemic_sex.female': true },
              key: 'mdiTesamorelinRefillSystemic_pregnantBreastfeedingPlanningPregnancy'
            },
            {
              condition: { 'mdiTesamorelinRefillSystemic_pregnancy.yes': true },
              key: 'mdiTesamorelinRefillSystemic_pregnantBreastfeedingPlanningPregnancy'
            }
          ],
          els: 'mdiTesamorelinRefillSystemic_sinceLastRefillProblemsHaving'
        }
      },
      'mdiTesamorelinRefillSystemic_pregnantBreastfeedingPlanningPregnancy',
      'mdiTesamorelinRefillSystemic_sinceLastRefillProblemsHaving',
      'mdiTesamorelinRefillSystemic_labsCompletedWhileMedication',
      {
        key: 'mdiTesamorelinRefillSystemic_updateMessageDoctor',
        next: {
          condition: {
            'mdiTesamorelinRefillSystemic_pregnantBreastfeedingPlanningPregnancy.yes_one_of_these':
              true
          },
          key: 'mdiTesamorelinRefillSystemic_duePregancyPlanningBreastfeedingStatus',
          els: 'mdiTesamorelinRefillSystemic_complete'
        }
      },
      'mdiTesamorelinRefillSystemic_duePregancyPlanningBreastfeedingStatus',
      'mdiTesamorelinRefillSystemic_complete'
    ]
  };
